import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';
import DiversityInclusionPage from '../components/company/diversity-inclusion-page';

const DiversityInclusionRoute = () => (
  <Fragment>
    <DocumentTitle title="Diversity & Inclusion | NerdWallet" />
    <DiversityInclusionPage />
  </Fragment>
);

DiversityInclusionRoute.displayName = 'Diversity Inclusion Route';
DiversityInclusionRoute.analyticsName = 'diversity_inclusion_page';

export default DiversityInclusionRoute;
